var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticStyle:{"width":"100%"}},[_c('iframe',{ref:"iframe",staticStyle:{"border":"none","overflow":"hidden"},attrs:{"width":"100%","height":"390"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }